import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { useNavigate, Link } from "react-router-dom";
import qs from "qs";
import ReactLoading from "react-loading";
import { PAGE_SIZE } from "./getListParams";
import Pagination from "rc-pagination";
import { BlogNoData } from "../../blocks/blog-no-data";
import { dateFormat } from "../../utils";

export const List = ({ loading, setPage, blogList, page, total }) => {
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const query = qs.parse(search.slice(1));
    if (!query.page) {
      setPage(1);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const onPageChange = (page) => {
    setPage(page);
    navigate(
      `/blog?${qs.stringify({
        ...qs.parse(search.slice(1)),
        page,
      })}`
    );
  };
  return (
    <>
      {loading ? (
        <div
          style={{
            minHeight: "calc(100vh - 160px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ReactLoading
            type="spinningBubbles"
            color="#215ae5"
            height={60}
            width={60}
          />
        </div>
      ) : Boolean(blogList?.length) ? (
        <div className="blog-lists-content">
          {blogList?.map((item) => {
            return (
              <Link
                to={`/blog/${item.id}${search}`}
                key={item.id}
                className="list-item"
              >
                <div className="list-item-text">
                  <div className="title">{item.title}</div>
                  <div className="content">
                    {item.content?.replace(/<.*?>/g, "")}
                  </div>
                  <div className="list-other">
                    <div className="author">
                      {item.author?.username || "--"}
                    </div>
                    <span className="split-dot">·</span>
                    <div className="time">
                      {dateFormat(item.publishedAt || item.published_at)}
                    </div>
                    <span className="split-dot">·</span>
                    <div className="views">{item.readCount || 0} 人阅读</div>
                    <div
                      onClick={(evt) => evt.stopPropagation()}
                      className="tags"
                    >
                      {item.tags.map((tag) => {
                        return (
                          <Link
                            to={`/blog/tag/${tag.id}`}
                            className="tag-item"
                            key={tag.id}
                          >
                            {tag.name}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {item.cover && (
                  <div className="item-cover-wrapper">
                    <div
                      className="item-cover"
                      style={{
                        backgroundImage: `url(${item.cover})`,
                      }}
                    ></div>
                  </div>
                )}
              </Link>
            );
          })}
        </div>
      ) : (
        <BlogNoData />
      )}
      {total > 10 && (
        <Pagination
          style={{
            marginBottom: 24,
          }}
          pageSize={PAGE_SIZE}
          onChange={onPageChange}
          current={page}
          total={total}
        />
      )}
    </>
  );
};
